import React, { useContext, useState, useMemo } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { GfsContext } from "../GFSRules";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelectWithSearch({dropDownList , selectedList , setSelectedList , label}) {
  // const {
  //   locationDropdown,
  //   setSelectedLocations,
  //   selectedLocations, // This is a CSV string like "N:US,N:CA"
  // } = useContext(GfsContext);

  const [searchText, setSearchText] = useState("");

  // All options (not filtered), used for matching selected values
  const allOptions = useMemo(() => {
    return Object.entries(dropDownList || {}).map(([key, value]) => ({
      key,
      value,
    }));
  }, [dropDownList]);

  // Selected options (objects) from the stored CSV string
  const selectedOptionObjects = useMemo(() => {
    const selectedIds = (selectedList || "").split(",").map((id) => id.trim());
    return allOptions.filter((option) => selectedIds.includes(option.value));
  }, [selectedList, allOptions]);

  // Filtered options for search input (top 150)
  const filteredNames = useMemo(() => {
    return allOptions
      .filter((option) =>
        option.key.toLowerCase().includes(searchText.toLowerCase())
      )
      .slice(0, 150);
  }, [allOptions, searchText]);

  return (
    <Autocomplete
      aria-required
      multiple
      id="checkboxes-tags-demo"
      options={filteredNames}
      value={selectedOptionObjects} // ✅ selected options based on CSV
      disableCloseOnSelect
      getOptionLabel={(option) => option?.key}
      onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
      onChange={(event, newSelectedOptions) => {
        const valuesOnly = newSelectedOptions.map((option) => option.value);
        const csv = valuesOnly.join(",");
        setSelectedList(csv);
      
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
            sx={{
              color: "#666",
              fontSize: "14px",
              "&.Mui-checked": {
                color: "#2d65c7",
              },
            }}
          />
          {option.key}
        </li>
      )}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Search..."
          sx={{
            "& label.Mui-focused": {
              color: "#2d65c7",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#ccc",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#2d65c7",
              },
            },
          }}
        />
      )}
    />
  );
}
